import { jsx as _jsx } from "react/jsx-runtime";
import { useDisclosure } from '@abb/uikit';
import { useCampaignNews } from 'hooks';
import React from 'react';
import { CampaignDetailModal } from './Notification/CampaignPanel/CampaignDetailModal';
export function CampaignNextModal() {
    var _data_content;
    const { isOpen, onClose } = useDisclosure({
        defaultIsOpen: true
    });
    const { data } = useCampaignNews();
    if (!data || data && !(data === null || data === void 0 ? void 0 : (_data_content = data.content) === null || _data_content === void 0 ? void 0 : _data_content.id)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CampaignDetailModal, {
        isOpen: isOpen,
        onClose: onClose,
        campaign: data.content
    });
}
